var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-screen flex flex-col"},[_c('TitleBar'),_c('div',{staticClass:"flex constrained flex-grow w-full"},[_c('NavMenu'),_c('main',{staticClass:"flex-grow min-w-0"},[_c('ContentColumn',[_c('Notifications'),_vm._t("default")],2)],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }